import React from 'react'

const EmailFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='14'
    viewBox='0 0 17 15'
    fill='none'
    {...props}
  >
    <path
      d='M1.83268 14.1668C1.37435 14.1668 0.981988 14.0036 0.655599 13.6772C0.32921 13.3509 0.166016 12.9585 0.166016 12.5002V2.50016C0.166016 2.04183 0.32921 1.64947 0.655599 1.32308C0.981988 0.996691 1.37435 0.833496 1.83268 0.833496H15.166C15.6243 0.833496 16.0167 0.996691 16.3431 1.32308C16.6695 1.64947 16.8327 2.04183 16.8327 2.50016V12.5002C16.8327 12.9585 16.6695 13.3509 16.3431 13.6772C16.0167 14.0036 15.6243 14.1668 15.166 14.1668H1.83268ZM8.49935 8.3335L15.166 4.16683V2.50016L8.49935 6.66683L1.83268 2.50016V4.16683L8.49935 8.3335Z'
      fill='currentcolor'
    />
  </svg>
)

export default EmailFilledIcon
